import { useId } from 'react';
import styles from './style.module.css';

function Slide(props: any) {
  return (
    <>
      <div
        id="carouselExampleControls"
        className={`carousel slide ${styles.carousel}`}
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">{props.children}</div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleControls"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </>
  );
}

function SlideItem(props: any) {
  const id = useId();

  function getUniqueId() {
    return id.replace(/:/g, '');
  }

  return (
    <>
      {props.slide ? (
        <div
          id={getUniqueId()}
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {props.slide.map((item: any) => {
              if (item.urlVideo) {
                return (
                  <div
                    key={item.urlVideo}
                    className={`carousel-item`}
                    data-bs-interval="5000"
                  >
                    <a
                      href={props.bannerLink ? props.bannerLink : null}
                      target="_blank"
                    >
                      <div className="ratio ratio-16x9">
                        <iframe
                          src={item.urlVideo}
                          allow="accelerometer; autoplay; loop; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </a>
                  </div>
                );
              }

              if (item.urlImages) {
                return (
                  item.urlImages &&
                  item.urlImages.map((image: any, index: number) => {
                    return (
                      <div
                        key={image.url}
                        className={`carousel-item ${
                          index === 0 ? 'active' : ''
                        }`}
                        data-bs-interval="5000"
                      >
                        <a
                          href={props.bannerLink ? props.bannerLink : null}
                          target="_blank"
                        >
                          <img
                            src={image.url}
                            className="d-block w-100"
                            alt={''}
                          />
                        </a>
                      </div>
                    );
                  })
                );
              }
            })}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target={`#${getUniqueId()}`}
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target={`#${getUniqueId()}`}
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      ) : (
        <div
          className={`carousel-item ${props.active ? 'active' : ''}`}
          data-bs-interval="5000"
        >
          <a href={props.bannerLink ? props.bannerLink : null} target="_blank">
            <img
              src={props.image}
              className="d-block w-100"
              alt="Imagem do item do slide"
            />
          </a>
        </div>
      )}
    </>
  );
}

export { Slide, SlideItem };
